
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";

const BeginnerFAQ = () => {
  return (
    <section className="py-20 px-4 bg-white border-t border-blue-100">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-16">
          <Badge className="px-3 py-1 text-sm bg-blue-600 text-white border-blue-700 mb-4">
            Common Questions
          </Badge>
          <h2 className="text-3xl md:text-5xl font-bold mb-6">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Everything you need to know about creating your first Google Ad with Upfixe.
          </p>
        </div>
        
        <div className="space-y-6">
          <Card>
            <CardContent className="p-6">
              <h3 className="text-xl font-bold mb-2">Do I need any Google Ads experience?</h3>
              <p className="text-muted-foreground">
                Not at all! Upfixe is specifically designed for beginners with zero experience. Our platform guides you through the entire process without requiring any technical knowledge.
              </p>
            </CardContent>
          </Card>
          
          <Card>
            <CardContent className="p-6">
              <h3 className="text-xl font-bold mb-2">How long does it take to create an ad?</h3>
              <p className="text-muted-foreground">
                Just 5 minutes! Answer a few simple questions about your business, and our AI will create a complete campaign that's ready to launch. No complicated setup required.
              </p>
            </CardContent>
          </Card>
          
          <Card>
            <CardContent className="p-6">
              <h3 className="text-xl font-bold mb-2">How much does it cost to run Google Ads?</h3>
              <p className="text-muted-foreground">
                You control your Google Ads budget. You can start with as little as $10/day, and our platform will help you optimize your spending to get the best results possible.
              </p>
            </CardContent>
          </Card>
          
          <Card>
            <CardContent className="p-6">
              <h3 className="text-xl font-bold mb-2">Do I need a Google Ads account first?</h3>
              <p className="text-muted-foreground">
                Yes, but we'll guide you through setting one up if you don't have one already. It takes just a few minutes, and once it's connected, you can create and publish ads directly from our platform.
              </p>
            </CardContent>
          </Card>
          
          <Card>
            <CardContent className="p-6">
              <h3 className="text-xl font-bold mb-2">What if I need help?</h3>
              <p className="text-muted-foreground">
                Our beginner-friendly support team is always available to help. We also provide simple tutorials and guides within the app to answer common questions.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default BeginnerFAQ;
